import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import pickerOption from '@/mixins/module/pickerOption';
import { mapState } from 'vuex';
import { auditEmail, auditRepairOrder } from "@/api/gmToolNew/gmToolNew";
export default {
  mixins: [pickerOption],
  data: function data() {
    return {
      reqLoading: false,
      currentPage: 1,
      total: 0,
      pageSize: 10,
      tableData: [],
      // 表格数据
      tableCopyTableList: [],
      // 表格copy数据b
      tagList: [{
        name: this.$t('tagAddB'),
        content: '<b></b>'
      }, {
        name: this.$t('tagAddI'),
        content: '<i></i>'
      }, {
        name: this.$t('tagAddSize'),
        content: '<size=50></size>'
      }, {
        name: this.$t('tagAddColor'),
        content: '<color=#FFFFFF></color>'
      }, {
        name: this.$t('tagAddMaterial'),
        content: '<material=2></material>'
      }, {
        name: this.$t('tagAddQuad'),
        content: '<quad material=1 size=20 x=0.1 y=0.1 width=0.5 height=0.5>'
      }],
      emailType: [{
        label: this.$t('sendToAll'),
        value: 1
      }, {
        label: this.$t('sendToTargetAccount'),
        value: 2
      }, {
        label: this.$t('compensationEmail'),
        value: 3
      }],
      // 语言以 value 为准
      Language: [{
        label: this.$t('langEnglish'),
        value: '0',
        text: 'en',
        disabled: false
      }, {
        label: this.$t('langTraditionalChinese'),
        value: '1',
        text: 'tc',
        disabled: false
      }, {
        label: this.$t('langSimplifiedChinese'),
        value: '2',
        text: 'zh',
        disabled: false
      }, {
        label: this.$t('langVietnamese'),
        value: '3',
        text: 'vn',
        disabled: false
      }],
      itemType: [{
        label: '货币',
        value: 10
      }, {
        label: '装备',
        value: 1
      }, {
        label: '丹药/材料',
        value: 2
      }, {
        label: '特殊',
        value: 3
      }, {
        label: '灵宠/技能书',
        value: 4
      }, {
        label: '命星',
        value: 5
      }, {
        label: '秘籍/残卷',
        value: 6
      }, {
        label: '宝箱',
        value: 7
      }, {
        label: '外观',
        value: 8
      }, {
        label: '神通道藏',
        value: 9
      }],
      serverLists: [],
      pageFnName: 'getList',
      paramsData: {
        page_size: 10,
        env_id: '',
        game_id: '',
        server_id: ''
      },
      payType: [{
        label: "google",
        value: 0
      }, {
        label: "apple",
        value: 1
      }, {
        label: "opengame",
        value: 2
      }],
      quality: [0, 1, 2, 3, 4, 5, 6],
      configState: [{
        label: this.$t('dynamicCalculation'),
        value: 0
      }, {
        label: this.$t('maintenance'),
        value: 1
      }, {
        label: this.$t('new'),
        value: 2
      }, {
        label: this.$t('full'),
        value: 3
      }, {
        label: this.$t('crowded'),
        value: 4
      }, {
        label: this.$t('smooth'),
        value: 5
      }],
      recommList: [{
        label: this.$t('neitherRecommendNorActivityZone'),
        value: 0
      }, {
        label: this.$t('onlyRecommend'),
        value: 1
      }, {
        label: this.$t('onlyActivityZone'),
        value: 2
      }, {
        label: this.$t('bothRecommendAndActivityZone'),
        value: 3
      }],
      isMobile: false // serverListYJ:[]

    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_this.szgmEnv.length) {
                _context.next = 6;
                break;
              }

              _context.next = 3;
              return _this.szgmEnv[0].id;

            case 3:
              _context.t0 = _context.sent;
              _context.next = 7;
              break;

            case 6:
              _context.t0 = '';

            case 7:
              _this.paramsData.env_id = _context.t0;
              _this.paramsData.game_id = _this.rawData.game_id;
              _this.pageFn = _this[_this.pageFnName];

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  computed: _objectSpread(_objectSpread({}, mapState("gmTool", {
    szgmItemList: function szgmItemList(state) {
      return state.init.itemList;
    }
  })), mapState("d2admin", {
    rawData: function rawData(state) {
      return state.serchSelect.rawData;
    },
    szgmEnv: function szgmEnv(state) {
      return state.user.useryjenv;
    }
  })),
  methods: {
    serverJud: function serverJud() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        if (!_this2.paramsData.server_id) {
          _this2.$message.error('请选择服务器');
        } else {
          resolve();
        }
      });
    },
    sizeChange: function sizeChange(e) {
      this.paramsData.page_size = e;
      this.pageFn && this.pageFn(1);
    },
    addtag: function addtag(data) {
      this.paramsData.context = "".concat(this.paramsData.context).concat(data);
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this3 = this;

      this.sels = [];
      val.forEach(function (e) {
        _this3.sels.push(e.id);
      });
      this.selsString = this.sels.toString();
    },
    // 页数改变事件
    handleSizeChange: function handleSizeChange(pageSize) {
      this.currentPage = 1;
      this.pageSize = pageSize;
      this.tableData = this.currentChangePage(pageSize, this.currentPage);
    },
    // 页码改变切换
    handleCurrentChange: function handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.tableData = this.currentChangePage(this.pageSize, currentPage);
    },
    // 分页方法
    currentChangePage: function currentChangePage(size, current) {
      var tablePush = [];
      this.tableCopyTableList.forEach(function (item, index) {
        if (size * (current - 1) <= index && index <= size * current - 1) {
          tablePush.push(item);
        }
      });
      return tablePush;
    },

    /**
     * 邮件公用方法类
     */
    // 审核邮件  type 1 通过 2 拒绝
    audit: function audit(row, type) {
      var _this4 = this;

      var data = {
        id: row.id,
        check_state: type,
        game_id: this.rawData.game_id
      };
      var loading = this.$loading({
        lock: true,
        text: this.$t('underReview'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      auditEmail(data).then(function (res) {
        loading.close();

        if (res.status == 200) {
          var index = _this4.tableData.findIndex(function (i) {
            return i.id == row.id;
          });

          _this4.tableData[index].check_state = type;

          _this4.$message.success(_this4.$t('operationSuccess'));
        }
      }).finally(function () {
        loading.close();
      });
    },
    auditOrder: function auditOrder(row, type) {
      var _this5 = this;

      var data = {
        id: row.id,
        state: type
      };
      auditRepairOrder(data).then(function (res) {
        if (res.status == 200) {
          var index = _this5.tableData.findIndex(function (i) {
            return i.id == row.id;
          });

          _this5.tableData[index].state = type;

          _this5.$message.success('操作成功');
        }
      });
    },
    checkMobile: function checkMobile() {
      this.isMobile = /Android|webOS|iPhone|iPod|BlackBerry|iPad|Windows Phone/i.test(navigator.userAgent) || window.innerWidth <= 768;
    }
  }
};